module.exports = __webpack_public_path__ + "img/match-drag.86f8bad1.svg";